import React from "react";
import QuestionCard from "../review/QuestionCard";
import AuthorReviewPanel from "../review/AuthorReviewPanel";
import StatusHistory from "../review/StatusHistory";

// The page of those who do not review the question: its author (who sees why it came back and resubmits it),
// a subject's viewer, and outside folders anyone without review rights. Its history carries the reviewers'
// comments. Main reads the question and its history (useQuestionPage) and draws the top bar above; `reload` reads
// them again.
export default function BasicPage({ question, history, historyLoading, historyFailed, reload, canVote = false }) {
  return (
    <div className="mx-auto w-full max-w-5xl space-y-6 motion-safe:animate-fade-in 2xl:max-w-screen-2xl">
      <div className="grid grid-cols-1 items-start gap-6 2xl:grid-cols-2">
        <QuestionCard question={question} showVotes={canVote} canVote={canVote} onVoted={reload} />

        <div className="space-y-6">
          <AuthorReviewPanel question={question} history={history} onChanged={reload} onReload={reload} />
          <StatusHistory
            history={history}
            loading={historyLoading}
            failed={historyFailed}
            authorUuid={question.author?.uuid}
          />
        </div>
      </div>
    </div>
  );
}
